module.exports = {
  GOOGLE_LOGIN_ERROR: 'Google login error',
  SKOLETUBE_LOGIN_ERROR: 'Skoletube login error',
}
